import { Icon, IconsEnum } from 'components/Icons';

import React from 'react';
import classNames from 'classnames';
import styles from './ScommesseTableQuotaSelectMenu.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type ScommesseTableQuotaSelectMenuProps = {
  title?: string;
  children: React.ReactNode;
  isBottom?: boolean;
  isRight?: boolean;
  handleClose: () => void;
};

// eslint-disable-next-line react/display-name
export const ScommesseTableQuotaSelectMenu = React.forwardRef<HTMLDivElement, ScommesseTableQuotaSelectMenuProps>(
  ({ ...props }, forwardedRef) => {
    const { isMobile } = useWindowSize();

    const { title, handleClose, children, isBottom, isRight } = props;

    return (
      <div
        className={classNames(
          styles.container,
          isBottom ? styles.bottom : styles.top,
          isRight ? styles.right : styles.left
        )}
        ref={forwardedRef}
      >
        {isMobile && (
          <div className={styles.header}>
            {/* TODO label da cms ? */}
            {title}
            <button type="button" className={styles.button} onClick={handleClose}>
              <Icon iconId={IconsEnum.CLOSE} className={styles.icon} color="var(--color-on-bg-primary)" />
            </button>
          </div>
        )}
        <div className={styles.main}>{children}</div>
      </div>
    );
  }
);

ScommesseTableQuotaSelectMenu.defaultProps = {
  title: 'Scegli la tua scommessa',
};
